import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";
import heroImg from "@/assets/hero-collage.jpg";
import { Sparkles, ArrowRight } from "lucide-react";

export const Hero = () => {
  const { t } = useI18n();
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
      <div className="container relative grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-neon-green/30 bg-neon-green/5 text-neon-green text-xs font-semibold uppercase tracking-widest">
            <Sparkles className="w-3.5 h-3.5" />
            {t("hero.tag")}
          </div>
          <h1 className="font-display text-5xl md:text-7xl font-black leading-[0.95]">
            <span className="text-gradient">{t("hero.title")}</span>
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-xl">{t("hero.subtitle")}</p>
          <div className="flex flex-wrap gap-3 pt-2">
            <Button asChild size="lg" className="bg-neon-green text-background hover:bg-neon-green/90 font-bold text-base h-12 px-7 animate-pulse-glow">
              <a href="#upload">
                {t("hero.cta")} <ArrowRight className="w-4 h-4" />
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-neon-purple/50 text-foreground hover:bg-neon-purple/10 hover:border-neon-purple h-12 px-7">
              <a href="#styles">{t("hero.secondary")}</a>
            </Button>
          </div>
          <div className="flex items-center gap-6 pt-4 text-sm text-muted-foreground">
            <div><span className="text-neon-green font-bold">500+</span> {t("hero.stat1")}</div>
            <div><span className="text-neon-green font-bold">4.9★</span> {t("hero.stat2")}</div>
            <div><span className="text-neon-green font-bold">~30s</span> {t("hero.stat3")}</div>
          </div>
        </div>
        <div className="relative animate-float">
          <div className="absolute -inset-6 bg-gradient-to-tr from-neon-green/30 via-transparent to-neon-purple/30 blur-3xl" />
          <div className="relative rounded-2xl overflow-hidden border border-neon-green/30 glow-purple">
            <img src={heroImg} alt="AI cartoon portrait examples in Neon, Anime, Comic, Cartoon, Ghibli, Oil Painting, Disney, Headshot and Caricature styles" width={1536} height={1024} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </section>
  );
};
